import { FormControl, FormLabel, Input, InputGroup, InputRightElement, IconButton, InputProps } from '@chakra-ui/react';
import { useState } from 'react';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

interface PasswordInputProps extends InputProps {
  label: string;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({ label, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  return (
    <FormControl isRequired>
      <FormLabel>{label}</FormLabel>
      <InputGroup>
        <Input
          type={showPassword ? 'text' : 'password'}
          {...props}
        />
        <InputRightElement>
          <IconButton
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            icon={showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            onClick={togglePasswordVisibility}
            variant="ghost"
            size="sm"
          />
        </InputRightElement>
      </InputGroup>
    </FormControl>
  );
};
